import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "table-default"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "semi-bold text-highlighted" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "no-request-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header" }, "Hold Requests", -1)),
    ($setup.initialHolds)
      ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header) => {
                return (_openBlock(), _createElementBlock("th", { key: header }, _toDisplayString(header), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.initialHolds, (initialHold, idx) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "cursor-pointer",
                key: idx,
                onClick: ($event: any) => ($setup.onManageInitialHold(initialHold._id))
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString($setup.getFullName(initialHold)), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(initialHold.leadsDetails.email), 1),
                _createElementVNode("td", null, _toDisplayString(initialHold.leadsDetails.phone), 1),
                _createElementVNode("td", null, _toDisplayString(initialHold?.companyDetails || "-"), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["badge", $setup.getInitialHoldStatusClass(initialHold.status)])
                  }, _toDisplayString($setup.getInitialHoldStatusText(initialHold.status)), 3)
                ]),
                _createElementVNode("td", null, _toDisplayString($setup.formatDate(initialHold.createdAt)), 1),
                _createElementVNode("td", null, _toDisplayString($setup.getExpirationDate(initialHold.expirationDate)), 1),
                ($setup.canManageLot)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                      _createElementVNode("button", {
                        class: "button primary button-manage",
                        onClick: ($event: any) => ($setup.onManageInitialHold(initialHold._id))
                      }, "Manage", 8, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "no-request" }, "You have no Hold Requests for this lot yet", -1)
        ]))]))
  ]))
}